/**
 * Extrae un mensaje de error legible desde una respuesta de la API.
 * FastAPI/Pydantic devuelven detail como string para errores de negocio
 * o como array para errores de validacion ([{loc, msg, type}, ...]).
 *
 * Tambien clasifica errores de red (sin response) en mensajes claros para
 * que el usuario sepa si el backend esta caido vs si las credenciales
 * son incorrectas.
 */
export function formatApiError(e: unknown, fallback = "Error"): string {
  const anyE = e as any;

  // Error de red (sin response del servidor): backend caido, timeout, CORS, etc.
  if (anyE && !anyE.response) {
    const code: string | undefined = anyE.code;
    if (code === "ECONNABORTED" || /timeout/i.test(anyE.message || "")) {
      return "El servidor tardo demasiado en responder. Verifica que el backend este corriendo.";
    }
    if (code === "ERR_NETWORK" || /Network Error/i.test(anyE.message || "")) {
      return "No se pudo conectar al servidor. Verifica que el backend este corriendo en el puerto 8000.";
    }
  }

  const detail = anyE?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        const loc = Array.isArray(d?.loc) ? d.loc.filter((x: unknown) => x !== "body").join(".") : "";
        const msg = d?.msg || "invalid";
        return loc ? `${loc}: ${msg}` : msg;
      })
      .filter(Boolean);
    if (parts.length) return parts.join("; ");
  }
  if (anyE?.message && typeof anyE.message === "string") {
    return anyE.message;
  }
  return fallback;
}
